import { trimObjectValues } from '@/utilz';
import type { ShipmentItrackStatusTypeResponse } from './api';

export const normalizeShipmentItrackStatusType = (
  list: ShipmentItrackStatusTypeResponse,
): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) =>
    trimObjectValues({
      label: row.codeDesc,
      value: row.codeId,
    }),
  );
};
